import { BsChevronDown, BsChevronRight, BsChevronUp } from "react-icons/bs";
import cn from "../../../lib/cn";
import P from "../../../shared/typography/P";
import Accordion from "../../../shared/ui/Accordian/Accordian";
import StaticLabelDropdown from "../../../shared/ui/Dropdown/StaticLabelDropdown";

const SideBar = ({
    proposalData,
    currentProposal,
    onUpdate = () => {},
    panels = false,
    panelTypes,
    onUpdatePanelType = () => {},
    currentPanelType,
    connectionType,
    mobilePannelTypes,
}) => {
    const mapPanelTypesToDropdownFormat = (panelTypes) => {
        return panelTypes?.map((panel) => (
            <div
                key={panel.id}
                className="flex justify-between items-center"
                onClick={() => onUpdatePanelType(panel)}
            >
                <P
                    className={cn(
                        "text-blue-100 lg:text-gray-120 lg:text-sm xl:text-sm",
                        {
                            "lg:text-blue": currentPanelType?.id === panel?.id,
                        }
                    )}
                >
                    {panel.label}
                </P>
                <div
                    className={cn(
                        "hidden lg:block lg:bg-gray-140 w-1 h-1 rounded-full",
                        {
                            "lg:bg-blue": currentPanelType?.id === panel?.id,
                        }
                    )}
                ></div>
                <BsChevronRight className="lg:hidden" />
            </div>
        ));
    };
    const currentId =
        typeof currentProposal === "object"
            ? currentProposal?.id
            : currentProposal;
    const mapItemsToDropdownFormat = (items) => {
        if (!Array.isArray(items)) return null;

        return items
            ?.slice()
            ?.sort((a, b) => {
                const aId = typeof a === "object" ? a?.id : a;
                const bId = typeof b === "object" ? b?.id : b;
                return bId - aId;
            })
            ?.map((item) => {
                const id = typeof item === "object" ? item?.id : item;

                return (
                    <div
                        key={id}
                        role="button"
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => onUpdate(item)}
                    >
                        <P
                            className={cn(
                                "text-blue-100 lg:text-gray-120 lg:text-sm xl:text-sm",
                                {
                                    "lg:text-blue": currentId === id,
                                }
                            )}
                        >{`Proposal ID # ${id}`}</P>
                        <div
                            className={cn(
                                "hidden lg:block lg:bg-gray-140 w-1 h-1 rounded-full",
                                {
                                    "lg:bg-blue": currentId === id,
                                }
                            )}
                        ></div>
                        <BsChevronRight className="lg:hidden" />
                    </div>
                );
            });
    };

    let label = mobilePannelTypes.find(
        (type) => type.id === currentPanelType?.id
    )?.label;
    return (
        <>
            {panels &&
                (connectionType === "Residential Society" ||
                    connectionType === "Individual Homes") && (
                    <>
                        <div className="bg-white hidden lg:block ">
                            <Accordion
                                title="Panel Type"
                                Open={true}
                                className={
                                    "border-b border-b-blue-400 text-nowrap"
                                }
                                content={
                                    <div className="flex mt-2 flex-col gap-1">
                                        {mapPanelTypesToDropdownFormat(
                                            panelTypes
                                        )}
                                    </div>
                                }
                                openIcon={<BsChevronUp />}
                                closeIcon={<BsChevronRight />}
                            />
                        </div>
                        <div className="flex lg:hidden items-center ">
                            <div className="w-[70%] ">
                                <StaticLabelDropdown
                                    label={
                                        <P className="text-white text-nowrap">
                                            {label}
                                        </P>
                                    }
                                    items={mapPanelTypesToDropdownFormat(
                                        mobilePannelTypes
                                    )}
                                    Icon={
                                        <BsChevronDown className="text-white ml-1" />
                                    }
                                    menuClass=" left-2"
                                />
                            </div>
                        </div>
                    </>
                )}
            <div className="bg-white hidden lg:block ">
                <Accordion
                    title="Proposals"
                    Open={true}
                    className={"border-b border-b-blue-400 text-nowrap"}
                    content={
                        <div className="flex mt-2 flex-col gap-1">
                            {mapItemsToDropdownFormat(proposalData)}
                        </div>
                    }
                    openIcon={<BsChevronUp />}
                    closeIcon={<BsChevronRight />}
                />
            </div>
            <div className="flex lg:hidden items-center gap-2 mr-3">
                <div className="w-[70%]">
                    <StaticLabelDropdown
                        label={
                            <P className="text-white text-nowrap">
                                Proposal ID #{currentId}
                            </P>
                        }
                        items={mapItemsToDropdownFormat(proposalData)}
                        Icon={<BsChevronDown className="text-white ml-1" />}
                    />
                </div>
            </div>
        </>
    );
};

export default SideBar;
